<template>
  <div class="scene_add">
    <div class="left">
      <scene-round :device="b" v-for="b in devices" :key="`switch_${b.name}`" @change="(c)=>{b.checked=c}">
        <img :src="require('@/assets/images/device/switch/device_spotlight_e.png')" style="width:60px " slot="icon"/>
        <div class="pd20">
          <el-form label-width="60px">
            <el-form-item label="开关：">
              <div class="text-right">
                <img :src="getIcon(b.state)" class="pointer" style="width: 80px" @click="b.state=!b.state"/>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </scene-round>
    </div>
    <div class="right">
      <el-form label-width="60px">
        <el-form-item label="开关：">
          <div class="text-right">
            <img :src="getIcon(device.state)" class="pointer" style="width: 80px" @click="device.state=!device.state"/>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SceneRound from './Round'
import api from '@/model/device'
import comm from '@/assets/lib/comm'

export default {
  name: 'SceneSpotlight',
  props: {
    command: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return { device: { state: 1 }, devices: [] }
  },
  computed: {
    ...mapState(['extDevices', 'extDevicesOrign'])
  },
  components: {
    SceneRound
  },
  watch: {
    extDevices () {
      this.devices = this.extDevices.filter(d => d.devicetype.key === 'switch' && d.name.indexOf('射灯') > -1).map(d => {
        return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, state: this.device.state, checked: false, cmd: { ...d.cmd } }
      })
      this.syncCommand()
    },
    device: {
      deep: true,
      handler () {
        this.devices.forEach(b => {
          b.state = this.device.state
        })
      }
    }
  },
  created () {
    this.devices = this.extDevices.filter(d => d.devicetype.key === 'switch' && d.name.indexOf('射灯') > -1).map(d => {
      return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, state: this.device.state, checked: false, cmd: { ...d.cmd } }
    })
    this.$hub.$on('getCommand', this.reportCommand)
  },
  mounted () {
    // 同步一次命令
    this.syncCommand()
  },
  deactivated () {
    this.reportCommand()
  },
  methods: {
    getIcon (state) {
      if (state) {
        return require('@/assets/images/home/open.png')
      } else {
        return require('../../assets/images/home/close.png')
      }
    },
    syncCommand () {
      this.command.forEach(c => {
        // 同步命令至当前模板
        if (this.devices.map(b => b.nd).includes(c.nd)) {
          const devices = this.devices.filter(b => b.nd === c.nd)
          devices.forEach(device => {
            device.checked = true
            // 找到匹配项之后，开始解析支持的命令
            const actions = JSON.parse(device.cmd.action)
            // 找到命令中包含的动作
            Object.keys(actions).forEach(name => {
              if (comm.containObject(c, actions[name])) {
                // 包含了指定的动作，那么该动存在，需要将其转换为对应的属性并进行赋值
                const obj = this.$parent.resolveAction(name, true)
                device[obj.key] = obj.value
              }
            })
          })
        }
      })
    },
    reportCommand () {
      // 同步数据
      const command = []
      this.devices.filter(d => d.checked).forEach(b => {
        // 对于多控制器的特殊处理
        let obj = this.extDevicesOrign.filter(item => item.nd === b.nd && item.deviceId !== b.deviceId)
        if (obj && obj.length) {
          obj.forEach(item => {
            command.push(Object.assign(api.generateCommand(b, b.state ? 'open' : 'close'), { deviceId: item.deviceId }))
          })
        } else {
          command.push(Object.assign(api.generateCommand(b, b.state ? 'open' : 'close'), { deviceId: b.deviceId }))
        }
        // if (b.state) {
        //   command.push(Object.assign(api.generateCommand(b, 'open'), { deviceId: b.deviceId }))
        // } else {
        //   command.push(Object.assign(api.generateCommand(b, 'close'), { deviceId: b.deviceId }))
        // }
      })
      // debugger
      this.$emit('changeCommand', command, this.devices.filter(d => !d.checked).map(d => {
        return { deviceId: d.deviceId, nd: d.nd, sid: d.sid }
      }))
    }
  }
}
</script>

<style scoped lang="less">
.scene_add {
  margin-top: 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 0px 20px 0px 20px;
  > .left {
    flex: 1;
    padding-right: 30px;
    padding-top: 20px;
    width: 0;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    .pd20 {
      padding: 0px 20px;
    }
  }
  > .right {
    overflow-y: auto;
    padding-top: 20px;
    padding-left: 20px;
    width: 300px;
    border-left: 1px solid #DFE1E5;
    & .form {
      display: flex;
    }
  }
}
</style>
